import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import closeBtn from '@/assets/images/close.png'
// import wechat from '@/assets/images/wechat.png'
// import wechatmoment from '@/assets/images/wechat_moment.png'
import shareImg from '@/assets/images/share.jpg'
import savep from '@/assets/images/savep.png'
import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';

const ShareModal = (props) => {
  let { shareMState, handleShowShareModal, cxname, QrCodeUrl, actUrl } = props,
    opacity = 0,
    bottom = '108%',
    pointerE = 'none';

  const imgRef = useRef(null)
  //版本判定
  let [isAndroid, setIsAndroid] = useState(false)
  let [isIOS, setIsIOS] = useState(false)
  let [iOSVer, setiOSVer] = useState('')
  //截图dom
  let shareBanner = useRef(null);
  //二维码宽度
  let [QRCodeW, setQRCodeW] = useState(100)
  //分享模态框
  if (shareMState) {
    opacity = 1;
    bottom = '9%';
    pointerE = 'auto'
  }

  // 遮罩层点击隐藏模态框
  const handleChangeShow = (e) => {
    let _target = e.target.tagName, _className = e.target.className
    if (_target === 'DIV' && _className === 'share-modal__box') {
      handleShowShareModal()
    }
  }
  // 分享至微信
  // const handleOnShareToWechat = () => {
  //   var u = navigator.userAgent;
  //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  //   let params = { url: "http://www.baidu.com", title: 'title标题', subTitle: 'subtitle' };
  //   if (isAndroid) {
  //     window.shareFriends.onShareFriend(JSON.stringify(params))
  //   } else if (isIOS) {
  //     window.WebViewJavascriptBridge.callHandler('handleShareToWechat', params);
  //   }
  // }
  // 分享至朋友圈
  // const handleOnShareToWechatMonment = () => {
  //   var u = navigator.userAgent;
  //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  //   let params = { url: "http://www.baidu.com", title: 'title标题', subTitle: 'subtitle' };
  //   if (isAndroid) {
  //     window.shareMoments.onShareMoments(JSON.stringify(params))
  //   } else if (isIOS) {
  //     window.WebViewJavascriptBridge.callHandler('handleShareToWechatMonment', params);
  //   }
  // }
  // 保存图片
  const handleOnSavePhone = () => {
    // const dom = shareBanner.current.getBoundingClientRect()
    console.log(iOSVer,"iOSVer")
    let y = 0 
    if(isIOS&&(+iOSVer>13)){
      y = 550
    }
    //截图
    html2canvas(shareBanner.current, {
      allowTaint: false,
      useCORS: true,
      scale: 2,
      // imageTimeout : 10000,
      proxy: 'https://szxhoss.pokongchuxing.com',
      dpi: window.devicePixelRatio * 2,
      // x: dom.left,
      // y: dom.top,
      // y
    }).then(function (canvas) {
      let d = canvas.toDataURL('image/png');
      //截取只保留base64 字符串
      let packD = d.substring(d.indexOf(',') + 1);
      // 截图成功

      // var u = navigator.userAgent;
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let params = {
        title: 'img',
        url: packD
      }
      if (isAndroid) {
        window.savePicture.onSavePicture(packD);
      } else if (isIOS) {
        window.WebViewJavascriptBridge.callHandler('handleSavePhone', params);
      }
    })
  }
  const isComplete = () => {
    if (imgRef.current.complete) {
      console.log('图片加载完成')
      handleOnSavePhone()
    } else {
      console.log(imgRef.current, "this.$refs.img")
      setTimeout(isComplete, 200)
    }
  }

  // useEffect
  useEffect(() => {
    let dataDpr = document.querySelector('html').getAttribute('data-dpr');
    if (dataDpr < 2) {
      setQRCodeW(50)
    }
  }, [QRCodeW])
  useEffect(() => {
    let u = navigator.userAgent;
    let str= navigator.userAgent.toLowerCase(); 
    setIsAndroid(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1);
    setIsIOS(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/));
    if(isIOS){
      let ver=str.match(/cpu iphone os (.*?) like mac os/);
      setiOSVer(ver[1]?.split('_')[0])
    }
  },[])

  return (
    <div className="share-modal__box" onClick={handleChangeShow} style={{ opacity: opacity, pointerEvents: pointerE }}>
      <div className="share-move" style={{ transform: `translateY(${bottom})` }}>
        <div className="close-btn__box">
          <img src={closeBtn} onClick={handleShowShareModal} alt="" />
        </div>
        <div className="share-banner" ref={shareBanner}>
          <div className="banner-img">
            <img ref={imgRef} src={actUrl ? actUrl : shareImg} alt="" />
          </div>
          <div className="qr-code__box">
            <article>
              <em>扫码注册</em>
              <span>加入{cxname}，即享好礼</span>
            </article>
            <aside>
              <QRCode
                value={QrCodeUrl}  //value参数为生成二维码的链接
                size={QRCodeW} //二维码的宽高尺寸
                fgColor="#000000"  //二维码的颜色
              />
            </aside>
          </div>
        </div>
        {/* <div className="share-tit">
          <em></em>
          <span>分享至</span>
          <em></em>
        </div> */}
        {/* <div className="share-btn__box"> */}
          {/* <div onClick={handleOnShareToWechat}>
            <img src={wechat} alt="" />
            <span>微信好友</span>
          </div>
          <div onClick={handleOnShareToWechatMonment}>
            <img src={wechatmoment} alt="" />
            <span>朋友圈</span>
          </div> */}
          {/* <div onClick={isComplete}>
            <img src={savep} alt="" />
            <span>保存照片</span>
          </div> */}
          {/* <div className='share_btn'>
            <button onClick={isComplete} style={React.colorConfig ? React.colorConfig.buttonBg : {}} >保存海报<i className='iconfont icon-xiazai'></i></button>
          </div> */}
        {/* </div> */}
        <div className='share_btn'>
          <button onClick={isComplete} style={React.colorConfig ? React.colorConfig.buttonBg : {}} >保存海报<i className='iconfont icon-xiazai'></i></button>
        </div>
      </div>
    </div>
  )
}
export default ShareModal